import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';
import BlockAlert from '@components/BlockAlert/BlockAlert';

const BecomeAMaster = ({ master }) => {
  const isRequestSent = master && master.master && master.master.approved === false;

  return (
    <div className="become-master">
      <div className="annotation">
        <p>
          <FMessage id="slaves.become-master.p-1" />
        </p>
        <p>
          <FMessage id="slaves.become-master.p-2" />
        </p>
      </div>

      {master && !master.master && master.slave && (
        <BlockAlert
          type="warning"
          title={<FMessage id="slaves.connect.blocked.title" />}
          text={<FMessage id="slaves.connect.blocked" />}
        />
      )}

      {!isRequestSent && !master.slave && (
        <div>
          <Link
            to={{
              pathname: '/tickets/create',
              search: '?theme=masterAccount',
            }}
            className={`btn btn-primary btn-md form-group-btn ${isRequestSent ? 'disabled' : ''}`}
          >
            <FMessage id="slaves.become-master.request.btn" />
          </Link>
        </div>
      )}

      {isRequestSent && (
        <BlockAlert type="wait" title={<FMessage id="slaves.connect-to-master.request-sent" />} />
      )}
    </div>
  );
};

export default BecomeAMaster;
